"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_module_1 = require("./app/app.module");
const environment_ts_1 = require("../../service-lib/src/lib/environment.ts");
const common_bootstrap_1 = require("../../service-lib/src/lib/common-bootstrap");
async function bootstrap() {
    const commonBootstrap = new common_bootstrap_1.CommonBootstrap();
    const port = environment_ts_1.ENV.PORT_KNOWLEDGE_SERVICE ? parseInt(environment_ts_1.ENV.PORT_KNOWLEDGE_SERVICE, 10) : 3035;
    await commonBootstrap.bootstrap(port, app_module_1.AppModule, 'Knowledge Service');
}
bootstrap();
